var _defs, _rect, _polygon, _polygon2, _polygon3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _rect2, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpAdvertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.c,.d,.g{fill-rule:evenodd;}.c{fill:#fff;}.d{fill:#ffefe0;}.e,.f,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.f{fill:#3ca4ef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-advert-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "22.86 93.09 22.86 34.69 123.14 34.69 123.14 111.31 108.81 111.31 108.81 91.7 94.49 90.53 94.49 111.31 37.19 111.31 37.19 90.44 22.86 93.09"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "16.86 87.09 16.86 28.69 117.14 28.69 117.14 105.31 102.81 105.31 102.81 85.7 88.49 84.54 88.49 105.31 31.19 105.31 31.19 84.44 16.86 87.09"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "67 28.69 117.14 28.69 117.14 105.31 102.81 105.31 102.81 85.7 88.49 84.54 88.49 105.31 67 105.31 67 28.69"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.19,
    y1: 79.21,
    x2: 31.19,
    y2: 105.31
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 45.51,
    y1: 79.21,
    x2: 45.51,
    y2: 105.31
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 59.84,
    y1: 79.21,
    x2: 59.84,
    y2: 105.31
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 74.16,
    y1: 79.21,
    x2: 74.16,
    y2: 105.31
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 88.49,
    y1: 79.21,
    x2: 88.49,
    y2: 105.31
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 102.81,
    y1: 79.21,
    x2: 102.81,
    y2: 105.31
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 59.84,
    y1: 44.68,
    x2: 83.26,
    y2: 44.68
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 59.84,
    y1: 51.7,
    x2: 102.81,
    y2: 51.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 59.84,
    y1: 65.98,
    x2: 102.81,
    y2: 65.98
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 94.99,
    y1: 58.71,
    x2: 102.81,
    y2: 58.71
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 90.27,
    y1: 44.68,
    x2: 102.81,
    y2: 44.68
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 59.84,
    y1: 58.71,
    x2: 73.82,
    y2: 58.71
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 79.35,
    y1: 58.71,
    x2: 87.17,
    y2: 58.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 31.19,
    y: 44.68,
    width: 19.81,
    height: 21.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 38.35,
    y1: 99.75,
    x2: 38.35,
    y2: 90.35
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 38.35,
    y1: 85.76,
    x2: 38.35,
    y2: 86.95
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 38.35,
    y1: 81.61,
    x2: 38.35,
    y2: 82.8
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 52.68,
    y1: 99.75,
    x2: 52.68,
    y2: 90.35
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 52.68,
    y1: 85.76,
    x2: 52.68,
    y2: 86.95
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 52.68,
    y1: 81.61,
    x2: 52.68,
    y2: 82.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 67,
    y1: 99.75,
    x2: 67,
    y2: 90.35
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 67,
    y1: 85.76,
    x2: 67,
    y2: 86.95
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 67,
    y1: 81.61,
    x2: 67,
    y2: 82.8
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 81.32,
    y1: 99.75,
    x2: 81.32,
    y2: 90.35
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 81.32,
    y1: 85.76,
    x2: 81.32,
    y2: 86.95
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 81.32,
    y1: 81.61,
    x2: 81.32,
    y2: 82.8
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "16.86 87.09 16.86 28.69 117.14 28.69 117.14 105.31 102.81 105.31 102.81 85.7 88.49 84.54 88.49 105.31 31.19 105.31 31.19 84.44 16.86 87.09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpAdvertIcon);
export default __webpack_public_path__ + "static/media/CP-advert-icon.ff8e6b1355b916a2fd2ad33939549cc2.svg";
export { ForwardRef as ReactComponent };